import React from 'react';

import './access-container-header.scss';

type Props = {
  title: string
};

const AccessContainerHeader = ({ title }: Props) => (
  <header className="access-container-header">
    <h1 className="access-container-header__title">{title}</h1>
  </header>
);

export default AccessContainerHeader;
